import { createSlice } from "@reduxjs/toolkit";
import {
  CategoryInitialStatus,
  GetCategoryData,
  GetSingleCategoryData,
} from "../../../types/category/category";
import {
  createCategoryAsync,
  getAllCategoryAsync,
  updateCategoryAsync,
} from "./categoryApi";

const initialState: CategoryInitialStatus<
  GetCategoryData,
  GetSingleCategoryData
> = {
  loading: false,
  manageLoading: false,
  CategoryList: [],
  singleCategoryData: null,
  countCategory: 0,
};

const categorySlice = createSlice({
  name: "admin-category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createCategoryAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createCategoryAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createCategoryAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllCategoryAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllCategoryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.CategoryList = action.payload.data;
        state.countCategory = action.payload.length;
      })
      .addCase(getAllCategoryAsync.rejected, (state) => {
        state.loading = false;
        state.CategoryList = [];
        state.countCategory = 0;
      });

    // update
    builder
      .addCase(updateCategoryAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateCategoryAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateCategoryAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default categorySlice;
